import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {IStringAnyMap, BooxSessionService} from "lib-boox";
import {CommonModule} from "@angular/common";
import {RouterModule} from "@angular/router";

@Component({
  selector: 'host-reset-password',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CommonModule, RouterModule],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
  public controlEmail: FormControl = new FormControl('', [Validators.required, Validators.email]);
  public controlCode: FormControl = new FormControl('', [Validators.required]);
  public controlPassword: FormControl = new FormControl('', [Validators.required, Validators.minLength(6)]);
  public controlSignIn: FormControl = new FormControl(true);

  public resetPasswordForm: FormGroup;

  private _sending : boolean = false;

  @Input('email') public email: string = '';
  @Input('code') public code: string = '';

  @Output('success') public success: EventEmitter<void> = new EventEmitter<void>();
  @Output('failed') public failed: EventEmitter<IStringAnyMap> = new EventEmitter<IStringAnyMap>();

  constructor(
    private session : BooxSessionService,
  ){
    this.resetPasswordForm = new FormGroup({
      email: this.controlEmail,
      code: this.controlCode,
      new_password: this.controlPassword,
      signIn: this.controlSignIn,
    });
  }

  ngOnInit(): void {
    if(this.email){
      this.controlEmail.setValue(this.email);
    }
    if(this.code){
      this.controlCode.setValue(this.code);
    }
  }

  public send(){
    if(this.resetPasswordForm.invalid) return;
    this._sending = true;
    this.session.resetPassword(this.resetPasswordForm.value).subscribe({
      next: () => {
        this.success.emit();
        this._sending = false;
      },
      error: (error) => {
        this.failed.emit(error);
        this._sending = false;
      },
    });
  }

  public get disabled(){
    return this.resetPasswordForm.invalid || this._sending;
  }
}
